import styles from "../styles.module.css";
import { useState, useEffect, useContext } from "react";
import { db } from "../../../firebase";
import { useParams } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import Authentication from "./authentication";
import Header from "./header";
import Call from "./call";
import Validator from "./validator";
import { UserValue } from "../../../contexts/user";
import { makeid } from "../../../utils/pageactions";
import { functions } from "../../../firebase";
import useAdminRequest from "../../../utils/useadminrequest";
const testApiConnection = functions.httpsCallable("testApiConnection");

export default function ApiEditor({ api, setApi }) {
  const [title, setTitle] = useState("");
  const { appId } = useParams();
  const [validate, setValidate] = useState(null);
  const { jwt } = useContext(UserValue);
  const request = useAdminRequest();

  useEffect(() => {
    setTitle(api.name);
  }, [api]);

  const handleSaveName = () => {
    const _api = { ...api };
    _api.name = title;
    setApi(_api);
    handleSave(_api);
  };

  const storeApiConnection = async ({ api }) => {
    const { data } = await request.post("/connection", { api });
    return data;
  };

  const handleSaveAuthentication = (v) => {
    const _api = { ...api };
    _api.authentication = v;
    setApi(_api);
    handleSave(_api);
    storeApiConnection({ api: _api }).then(({ data }) => {
      console.log("API DATA ", data);
    });
  };
  const handleSave = (_api) => {
    db.collection("apps").doc(appId).collection("apis").doc(api.id).set(_api);
  };
  //headers
  const addHeader = () => {
    const _api = { ...api };
    _api.headers.push({ key: "", value: "", id: makeid(16) });
    setApi(_api);
    handleSave(_api);
  };

  const testCall = (call) => {
    let url = call.url;
    const headers = {};
    let body;
    try {
      body = JSON.parse(call.body);
    } catch (err) {
      body = call.body;
    }

    if (call.bodyParams) {
      call.bodyParams.forEach((p) => {
        body = body.replace(`<${p.name}>`, p.default);
      });
    }

    call.params.forEach((p) => {
      url = url.replace(`[${p.name}]`, p.default);
    });

    api.headers.forEach((h) => {
      headers[h.key] = h.value;
    });
    call.headers.forEach((h) => {
      headers[h.key] = h.value;
    });

    setValidate({ call, loading: true });
    testApiConnection({
      url,
      headers,
      body,
      type: call.type,
      authentication: api.authentication
        ? {
            test_token: api.authentication.test_token,
            token_name: api.authentication.token_name,
          }
        : null,
    })
      .then((data) => {
        console.log(data);
        if (data.data.error) {
          return setValidate({ call, err: data.data });
        }
        setValidate({ call, data });
      })
      .catch((err) => {
        console.log(err.data);
        setValidate({ call, err: err.data });
      });
  };

  const saveSchema = (schema, call) => {
    const _api = { ...api };
    const index = _api.calls.findIndex((x) => x.id === call.id);
    call.schema = schema;
    _api.calls[index] = call;
    setApi(_api);
    handleSave(_api);
    setValidate(null);
    storeApiConnection({ api: _api, token: jwt, appId }).then(({ data }) => {
      console.log("API DATA ", data);
    });
  };

  const updateHeader = (newHeader, index) => {
    const _api = { ...api };
    _api.headers[index] = newHeader;
    setApi(_api);
    handleSave(_api);
  };
  const deleteHeader = (index) => {
    const _api = { ...api };
    _api.headers.splice(index, 1);
    setApi(_api);
    handleSave(_api);
  };

  //calls
  const addCall = () => {
    const _api = { ...api };
    _api.calls.push({
      type: "",
      url: "",
      body: "",
      name: "",
      params: [],
      bodyParams: [],
      headers: [],
      id: makeid(16),
    });
    setApi(_api);
    handleSave(_api);
  };

  const updateCall = (newCall, index) => {
    const _api = { ...api };
    _api.calls[index] = newCall;
    setApi(_api);
    handleSave(_api);
  };
  const deleteCall = (index) => {
    const _api = { ...api };
    _api.calls.splice(index, 1);
    setApi(_api);
    handleSave(_api);
  };

  return (
    <div className={styles.canvas}>
      <div className={styles.content}>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          className={styles.titleInput}
          onBlur={handleSaveName}
        />

        <Authentication
          onChange={handleSaveAuthentication}
          authentication={api.authentication}
          appId={appId}
          apiId={api.id}
        />

        <div className={styles.section}>
          <div className={styles.sectionTitle}>Shared Headers</div>
          {api.headers.map((h, index) => {
            return (
              <Header
                updateHeader={updateHeader}
                deleteHeader={deleteHeader}
                header={h}
                index={index}
                key={h.id}
              />
            );
          })}
          <div onClick={addHeader} className={styles.iconButton}>
            <MdAdd className={styles.icon} />
            Add
          </div>
        </div>

        <div className={styles.outTitle}>API Calls</div>
        {api.calls.map((c, index) => {
          return (
            <Call
              updateCall={updateCall}
              deleteCall={deleteCall}
              testCall={testCall}
              call={c}
              index={index}
              key={c.id}
            />
          );
        })}
        <div onClick={addCall} className={styles.iconButton}>
          <MdAdd className={styles.icon} />
          Add
        </div>
        <div style={{ height: 100 }}></div>
      </div>
      <Validator
        onSave={saveSchema}
        setValidate={setValidate}
        validate={validate}
      />
    </div>
  );
}
